import * as React from "react";
const SvgFiRrTrianglePersonDigging = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-triangle-person-digging_svg__a)">
      <path
        fill="#062147"
        d="M23.398 15.92 15.356 2.883C14.606 1.669 13.418 1 12.009 1c-1.424 0-2.621.669-3.37 1.883L.597 15.92a3.95 3.95 0 0 0-.088 4.047A3.91 3.91 0 0 0 3.963 22h16.07c1.452 0 2.743-.76 3.454-2.033a3.95 3.95 0 0 0-.09-4.047m-1.66 3.072A1.93 1.93 0 0 1 20.033 20H3.962a1.93 1.93 0 0 1-1.706-1.008 1.97 1.97 0 0 1 .043-2.022l3.974-6.442 8.002 5.455-.508.733a.819.819 0 0 0 .673 1.285h3.76a.99.99 0 0 0 .886-1.432l-1.558-3.116a.818.818 0 0 0-1.4-.107l-.884 1.252-5.26-3.629.388-.999a.675.675 0 0 1 .937-.377l.16.077c.413.205.727.557.886.991l.048.152a.72.72 0 0 0 .29.384c.55.362 1.259-.141 1.098-.779l-.074-.293a3.07 3.07 0 0 0-1.523-1.707l-.377-.188a1.97 1.97 0 0 0-2.731 1.098l-.326.805L7.167 9.08l3.175-5.146c.382-.619.943-.933 1.668-.933.72 0 1.258.305 1.645.933l8.042 13.037c.385.625.402 1.381.043 2.022zM13 6a1 1 0 1 1-2.001 0 1 1 0 0 1 2 0m-5.354 7.412 1.312.898-1.146 3.194a.75.75 0 0 1-.706.497h-.041a.75.75 0 0 1-.706-1.003l1.286-3.585zM10 15.037l1.5 1.09v1.123a.75.75 0 0 1-1.5 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-triangle-person-digging_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrianglePersonDigging;
